import { Component, Input, ChangeDetectionStrategy, ViewChild, inject } from '@angular/core';
import { FormQuestionType } from '@fi-shared/fi-form-shared/fi-form-enums';
import { IFormQuestion } from '@fi-shared/fi-form-shared/fi-form-shared';
import { FiFormQuestionBase } from '@fi-app/fi-form/fi-form-edit/fi-form-edit-form/fi-form-question-base';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { NgModel } from '@angular/forms';
import { FiChoiceQuestionValidateComponent } from '@fi-app/fi-form/fi-form-edit/fi-form-edit-form/fi-form-choice-question/fi-choice-question-validate.component';
import { FiFormService } from '@fi-app/fi-form/fi-form.service';
import { cloneDeep } from '@fi-app/shared/utils';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

@Component({
    selector: 'fi-choice-question',
    templateUrl: './fi-choice-question.component.html',
    styleUrls: ['./fi-choice-question.component.scss', '../fi-form-text-question/fi-form-text-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: FiComponentsContainer, useExisting: FiChoiceQuestionComponent }],
    standalone: false,
})
export class FiChoiceQuestionComponent extends FiFormQuestionBase {
    private fiFormService = inject(FiFormService);
    private contentLanguagesService = inject(ContentLanguagesService);

    @Input() isValidationErrorOnFormSave: boolean;
    @ViewChild('fiChoiceQuestionValidateComponent')
    fiChoiceQuestionValidateComponent: FiChoiceQuestionValidateComponent;
    @ViewChild('choiceQuestionValidateModel') choiceQuestionValidateModel: NgModel;

    protected getOptionInstanceFn = () => {
        const newOption = this.fiFormService.getNewOptionInstance();
        this.contentLanguagesService.InitializeContentLanguages(
            newOption,
            cloneDeep({
                Names: newOption.Names,
                Descriptions: [],
            }),
        );
        return newOption;
    };

    protected isOptionNameRequiredFn = (optionName: IContentLanguageLabelModel) => {
        return this.fiFormHelperService.isQuestionNameRequired(optionName, this.isFormTranslated);
    };

    protected onOptionDeleted(): void {
        this.fiFormHelperService.triggerDeleteQuestionPresetOptionEvent();
    }

    protected getElementIcon(): string {
        return this.fiFormHelperService.isSingleChoiceQuestion(this.question) ? 'fas fa-check' : 'fas fa-list-ul';
    }

    protected isMultipleChoiceQuestion(question: IFormQuestion): boolean {
        return question.Type === FormQuestionType.MultipleChoice;
    }

    protected getChoiceQuestionErrorMessages(): { [property: string]: string } {
        return {
            required: null,
            questionNoOptions: 'form.multiple_choice_no_options_error',
            singleChoicePresetOptionAmount: 'form.single_choice_no_options_error',
            questionOptionsNotTranslated: '',
        };
    }

    public onQuestionChanged(): void {
        super.onQuestionChanged();
        this.choiceQuestionValidateModel.control.updateValueAndValidity();
    }
}
